import type { SalesPointConfigurationResponseDTO } from '@/types/dto/agent';

export type PosPassengerType = NonNullable<
  SalesPointConfigurationResponseDTO['passengerTypes']
>[number];

const ADULT_PASSENGER_TYPE_CATEGORY_ID = 'PASSENGER_TYPE_CATEGORY.ADULT';

// Whether a POS passenger type counts as an adult, derived the way the search
// widget derives it for its own picker (`usePosConfiguration`): off the type's
// category, not off anything the caller supplies.
export function isAdultPassengerType(posType: PosPassengerType): boolean {
  return posType.passengerTypeCategory?.id === ADULT_PASSENGER_TYPE_CATEGORY_ID;
}

// The age to submit for a non-adult passenger whose age we do not know. The
// widget's form schema requires an age on every passenger that is not an
// adult, but a deep link's `passengers` parameter names a `passengerTypeId`
// and no age (BR-58550). Any age inside the type's [ageFrom, ageTo] window
// resolves back to the same passenger type, so an in-range value keeps the
// search valid without changing which fares apply.
//
// `ageFrom` is that value here because it is exactly what the widget's own
// picker submits when the customer adds this type by hand
// (`usePassengerTypePicker`), so a deep-linked roster and a hand-built one
// carry the same age.
export function deriveAgeFromPassengerType(
  posType: PosPassengerType
): number | undefined {
  return posType.validityCriterias?.[0]?.ageFrom;
}
